<mat-card>
  <mat-card-content>
    <div class="view-container">
      <mat-tab-group mat-stretch-tabs>
        <mat-tab label="Product Impressions">
          <div class="tab-content" fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center start" fxLayoutAlign.lt-md="start center">
            <asset-upload fxFlex="30%" fxFlex.lt-md="100%"
              [heading]="'UPDATE LOGO'"
              (asset)="onAssetLoad($event)"
              (saveAction)="onSaveClick()">
              <div class="" fxLayout="row" fxLayoutAlign="center center">
                <img class="" *ngIf="productImpressionLogo || manufacturer?.logoUrl" [src]="productImpressionLogo ? productImpressionLogo : manufacturer.logoUrl">
                <img class="" *ngIf="!productImpressionLogo && !manufacturer?.logoUrl" src="/assets/images/add-image-icon.svg">
              </div>
            </asset-upload>
            <div class="demo-container" fxFlex="70%" fxFlex.lt-md="100%" fxLayout="column" fxLayoutAlign="center center">
              <div class="situ-product-container">
                <div class="situ-manufacturer-logo" *ngIf="productImpressionLogo || manufacturer?.logoUrl">
                  <img [src]="productImpressionLogo ? productImpressionLogo : manufacturer.logoUrl">
                </div>
                <div class="situ-white-line"></div>
                <div class="situ-product-info">
                  Product Description<br><span class="situ-product-sku">SKU-0001</span>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <!-- <mat-tab [disabled]="true" label="Analytics"></mat-tab>
        <mat-tab [disabled]="true" label="Relationships"></mat-tab> -->
      </mat-tab-group>
    </div>
  </mat-card-content>
</mat-card>
